import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'nym-issuance-listing-no-results',
  templateUrl: './issuance-listing-no-results.component.html',
  styleUrls: ['./issuance-listing-no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuanceListingNoResultsComponent implements OnInit {

  @HostBinding('class.nym-issuance-listing-no-results')
  protected get classes(): boolean { return true; }

  constructor() { }

  public ngOnInit(): void { }

}
